import type { ChartBuilder, SupportedChartType } from './types';

const chartBuilderRegistry = new Map<SupportedChartType, ChartBuilder<SupportedChartType>>();

export const registerChartBuilder = <CT extends SupportedChartType>(
  chartType: CT,
  builder: ChartBuilder<CT>,
) => {
  chartBuilderRegistry.set(chartType, builder as ChartBuilder<SupportedChartType>);
};

export const getChartBuilder = <CT extends SupportedChartType>(chartType: CT): ChartBuilder<CT> => {
  const builder = chartBuilderRegistry.get(chartType);
  if (!builder) {
    throw new Error(`Unsupported chart type: ${chartType}`);
  }
  return builder as ChartBuilder<CT>;
};

export const getRegisteredChartTypes = () => {
  return Array.from(chartBuilderRegistry.keys());
};

export const clearChartBuilders = () => {
  chartBuilderRegistry.clear();
};

